import React from 'react'
import { logger } from 'APP/Lib/Datadog'
import { triggerEvent } from 'APP/BrownfieldBridge/BrownfieldBridgeInternal'
import { startupPhase } from 'APP/BrownfieldBridge/startupPhase'

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const componentStack = errorInfo.componentStack || 'Unknown component stack'

    logger.error('Uncaught error in component tree', { componentStack }, error)

    if (startupPhase.isActive()) {
      triggerEvent({
        type: 'JS_EXECUTION_ERROR',
        payload: {
          message: error?.message,
          stack: error?.stack,
          componentStack: componentStack,
        },
      })
    }
  }

  render() {
    return this.state.hasError ? null : this.props.children
  }
}
